import { apiCall } from '../helpers/axios';

class ImportService {

	static importNextlot(fileList) {
		return apiCall().post(`/persons/import/nextlot`, fileList)
			.then(response => response.data);
	}

}

export default ImportService


// WEBPACK FOOTER //
// ./src/services/import-service.js